const delivery = require('../assets/homepage/delivery.png');
const purchase = require('../assets/homepage/purchase.png');
const pay = require('../assets/homepage/pay.png');
const search = require('../assets/homepage/search.png');
const location = require('../assets/homepage/location.png');
const shipment = require('../assets/homepage/shipment.png');
const warehouse = require('../assets/homepage/warehouse.png');
const tracking = require('../assets/homepage/tracking.png');
const notification = require('../assets/homepage/notification.png');

export default {
    delivery,
    purchase,
    pay,
    search,
    location,
    shipment,
    warehouse,
    tracking,
    notification
}